import React from 'react';

const PackageInstrumentsListRightMenu = () => {
  return <></>;
};

export default PackageInstrumentsListRightMenu;
